import {Injectable} from "@angular/core";
import {PresentationConstants} from "@app/presentation/presentation.constants";
import {BehaviorSubject, fromEvent} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {WindowService} from "@app/core/shared/domain/window.service";
import {PlatformService} from './platform.service';

@Injectable({
    providedIn: 'root'
})
export class DisplayService {
    window?: Window | null = this.windowService.getWindow();


    isMobileDisplay = this.getIfIsMobileDisplay();

    private isMobileDisplaySubject = new BehaviorSubject(this.isMobileDisplay);

    isMobileDisplay$ = this.isMobileDisplaySubject.asObservable();

    isDesktopDisplay = !this.isMobileDisplay;

    isDesktopDisplay$ = this.isMobileDisplay$.pipe(map(isMobile => !isMobile));


    constructor(
        private windowService: WindowService,
        private platformService: PlatformService,
    ) {
       this.initializeResizeEventSubscription();

    }

    initializeResizeEventSubscription() {
        this.isMobileDisplaySubject.next(this.getIfIsMobileDisplay());

        if(this.platformService.isBrowser) {
            this.window?.addEventListener('resize', () => {
                this.isMobileDisplay = this.getIfIsMobileDisplay();
                this.isMobileDisplaySubject.next(this.getIfIsMobileDisplay());
            });
        }
    }

    private getIfIsMobileDisplay(): boolean {
        const isServer =  this.platformService.isServer;
        return isServer 
        ? this.platformService.isMobile
        : this.matchMediaQueryMaxWidthPx(PresentationConstants.mobileMaxWidthPx);
    }

    private matchMediaQueryMaxWidthPx(pixels: number) {
        if(!this.window) {
            return true;
        }
        return this.window.matchMedia(`(max-width: ${pixels}px)`).matches;
    }

    public matchMediaQueryMaxWidthPx$(pixels: number) {
        return fromEvent(window,'resize').pipe(
            map(() => this.matchMediaQueryMaxWidthPx(pixels)),
            startWith(this.matchMediaQueryMaxWidthPx(pixels)),
        )
    }

}
